import type { ComputePositionConfig } from '@floating-ui/react';
import type { Editor } from '@tiptap/react';
import { GripVertical } from 'lucide-react';
import { useCallback, useState } from 'react';
import { DragHandle } from '../drag-handle-react/DragHandle';

interface NodeInfo {
    node: any;
    editor: Editor;
    pos: number;
}

interface DragHandlerProps {
    editor: Editor;
    actions?: (nodeInfo: NodeInfo) => React.ReactNode;
    onNodeChange?: (nodeInfo: NodeInfo) => void;
    showDelete?: boolean;
}

const computePositionConfig: ComputePositionConfig = { strategy: 'absolute' };

export function ZyDragHandler({ editor, onNodeChange }: DragHandlerProps) {
    const [nodeInfo, setNodeInfo] = useState<NodeInfo | null>(null);

    const handleNodeChange = useCallback(
        (info: NodeInfo) => {
            setNodeInfo(info);
            onNodeChange?.(info);
        },
        [onNodeChange],
    );

    const isDraggable = nodeInfo?.node?.type?.spec?.draggable || false;

    return (
        <DragHandle
            className="pr-3 w-12 flex flex-col items-end"
            editor={editor}
            onNodeChange={handleNodeChange}
            computePositionConfig={computePositionConfig}
        >
            <div
                className={`flex flex-col w-8 gap-3 rounded border border-gray-300 bg-white px-1 py-2 shadow-sm hover:bg-gray-50 dark:border-gray-600 dark:bg-gray-800 dark:hover:bg-gray-700 ${!isDraggable ? 'hidden' : ''}`}
            >
                {/* Drag Handle Icon */}
                <div className="flex cursor-grab items-center justify-center text-gray-400 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200">
                    <GripVertical className="h-4 w-4" />
                </div>
            </div>
        </DragHandle>
    );
}

export default ZyDragHandler;
